'use client'

import React from 'react'
import Icon from '@/components/atoms/Icon'

import styles from './FloatingContacts.module.scss'

const DEFAULT_WHATSAPP_URL = 'https://wa.me/390297372106'
const DEFAULT_PHONE_URL = 'tel:00390297372106'

interface FloatingContactsProps {
  whatsappUrl?: string
  phoneUrl?: string
}

const FloatingContacts: React.FC<FloatingContactsProps> = ({
  whatsappUrl = DEFAULT_WHATSAPP_URL,
  phoneUrl = DEFAULT_PHONE_URL,
}) => {
  return (
    <div className={styles.wrapper}>
      <a
        href={phoneUrl}
        className={styles.button}
        aria-label='Phone'
      >
        <Icon
          iconName='Phone'
          width={20}
          height={20}
          fill='currentColor'
        />
      </a>
      <a
        href={whatsappUrl}
        target='_blank'
        rel='noopener noreferrer'
        className={styles.button}
        aria-label='WhatsApp'
      >
        <Icon
          iconName='WhatsappNew'
          width={20}
          height={20}
        />
      </a>
    </div>
  )
}

export default FloatingContacts
